// extracted by mini-css-extract-plugin
export const container = "cta-large-module--container--1sl7R";
export const illustration = "cta-large-module--illustration--3JdVo";
export const containerCopy = "cta-large-module--containerCopy--M5wa1";
export const title = "cta-large-module--title--3HWtz";
export const copy = "cta-large-module--copy--3h0Ej";